<template>
  <div id="sms-report">
    <div class="container">

      <Panel class="configurations" :title="$t('parameters')" collapsible>
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{$t('start')}}</label>
              <datetime
                v-model="parameters.start"
                type="date"
                value-zone="local"
                input-id="p_start"
                :input-class="{invalid: $validate.error('parameters.start')}"
                input-style="width: 100%"
              />
            </div>
          </div>
          <div class="column">
            <div class="group">
              <label>{{$t('end')}}</label>
              <datetime
                v-model="parameters.end"
                type="date"
                value-zone="local"
                input-id="p_end"
                :input-class="{invalid: $validate.error('parameters.end')}"
                input-style="width: 100%"
              />
            </div>
          </div>
        </div>
        <button class="btn btn-primary" @click="generate">{{$t('generate')}}</button>
      </Panel>

      <Panel ref="dataTab" v-if="table" :title="$t('result')">
        <RawTable
          :keyValueHeader="table.query"
          :columns="table.data.columns"
          :rows="table.data.rows"
        />
      </Panel>

    </div>
  </div>
</template>
<script>
  import { Core } from "@/core/Core";
  import RawTable from "@/components/RawTable";
  import moment from "moment-timezone";

  export default {
    name: "SmsReport",

    components: { RawTable },

    data() {
      return {
        parameters: {
          start: moment().toISOString(),
          end: moment().toISOString(),
        },
        table: null
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = 'advanced_navigation.sms_Report';
      this.$store.state.pageIcon = "/icon/wrench-lock.svg";
    },

    methods: {
      fixDateString(str) {
        return str ? str.replace('T', ' ').substring(0, 19) : null;
      },
      async generate() {
        let options = {
          start: this.fixDateString(this.parameters.start) || undefined,
          end: this.fixDateString(this.parameters.end) || undefined,
        };
        if (options.end) {
          options.end = options.end.replace('00:00:00', '23:59:59');
        }

        this.$store.commit("showSpinner", true);
        let response = await Core.request("GET", '/api/notification_sms/report', options);
        this.$store.commit("showSpinner", false);
        this.table = response;
        setTimeout(() => {
          this.$refs.tabs.setActive(this.$refs.dataTab);
        }, 0);
      }
    },

    validate: {
      "parameters.start": {
        required: true
      },
      "parameters.end": {
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media print {
    .configurations {
      display: none !important;
    }
    .tabs {
      display: none !important;
    }
  }
</style>
